/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoaTrustCertificateIssuerDN
 */
export interface LoaTrustCertificateIssuerDN {
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificateIssuerDN
     */
    name?: string;
}

export function LoaTrustCertificateIssuerDNFromJSON(json: any): LoaTrustCertificateIssuerDN {
    return LoaTrustCertificateIssuerDNFromJSONTyped(json, false);
}

export function LoaTrustCertificateIssuerDNFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaTrustCertificateIssuerDN {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function LoaTrustCertificateIssuerDNToJSON(value?: LoaTrustCertificateIssuerDN | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

